import type { IconSvgObject } from './types';

const Coffee03Icon: IconSvgObject = [
  ["path", { d: "M16 9H4C3.44772 9 3 9.44772 3 10V18C3 19.6569 4.34315 21 6 21H14C15.6569 21 17 19.6569 17 18V10C17 9.44772 16.5523 9 16 9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 11H19C20.1046 11 21 11.8954 21 13V15C21 16.1046 20.1046 17 19 17H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 3V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 3V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M6 3V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Coffee03Icon;
